import { createRouter, createWebHistory } from "vue-router";
import { globalState } from "@/globalState";
import { fetchUserData } from "@/api/accountsService";
import { getActiveThemeKey } from "@/Themes/themeRuntime";


import Dashboard from "../views/DashboardV3.vue";
import DashboardV3 from "../views/DashboardV3.vue";


import Valert from "../views/components/alert.vue";
import Vaccrodion from "../views/components/accordion.vue";
import Vbadges from "../views/components/badges.vue";
import Vbreadcumb from "../views/components/breadcumbs.vue";
import Vbutton from "../views/components/button.vue";
import Vcard from "../views/components/card.vue";
import Vdropdown from "../views/components/dropdown.vue";
import Vmodal from "../views/components/modal.vue";
import Login from "../views/layouts/auth/Login.vue";
import Register from "../views/layouts/auth/Register.vue";
import ForgotPassword from "../views/layouts/auth/forgot-password.vue";




import Blank from "../views/layouts/Blank.vue";


import Page404 from "../views/layouts/error/404.vue";
import Page500 from "../views/layouts/error/500.vue";
import PageMaintenance from "../views/layouts/error/maintenance.vue";


import Agents from "@/views/Agents.vue";
import Users from "@/views/Users.vue";
import Chat from "@/views/Chat.vue";
import AgentCreate from "@/views/AgentCreate.vue";
import AgentsReport from "@/views/AgentsReport.vue";
import Organization from "@/views/OrganizationDiagram.vue";
import ROIInsights from "@/views/ROIInsights.vue";
import OrganizationSettings from "@/views/OrganizationSettings.vue";
import OrganizationDiagram from "@/views/OrganizationDiagram.vue";
import ChatAgentV3 from "@/views/ChatAgentV3.vue";
import PublicChatWidgetLoader from "../views/PublicChatWidgetLoader.vue";

import AnalysisEngine from "@/views/AnalysisEngine.vue";
import Entities from "@/views/Entities.vue";
import ServicesSettings from "@/views/ServicesSettings.vue";
import CustomActions from "@/views/CustomActions.vue";
import Complainces from "@/views/Complainces.vue";
import ThirdPartyIntegrations from "@/views/ThirdPartyIntegrations.vue";
import Teams from "@/views/Teams.vue";
import APIKeys from "@/views/APIKeys.vue";
import AIChats from "@/views/AIChats.vue";
import ModernAIChats from "@/Themes/modern/views/AIChats.vue";
import LightAIChats from "@/Themes/light/views/AIChats.vue";
import AIChatAgentKnowledgeBase from "@/components/AIChatAgentKnowledgeBase.vue";
import AIChatAgentSetup from "@/views/AIChatAgentSetup.vue";
import AIChatAgentSetupLight from "@/views/AIChatAgentSetupLight.vue";
import AIPhoneIVRSetup from "@/views/AIPhoneIVRSetup.vue";
import VoiceAgentSetup from "@/views/VoiceAgentSetup.vue";
import VoicePlayground from "@/views/VoicePlayground.vue";
import AIChatAgent from "../views/ChatAgent.vue";
import ChatAgentV2 from "../views/ChatAgentV2.vue";
import ChatAgentAssistance from "../views/ChatAgentAssistance.vue";
import AIServicesConfiguration from "@/views/AIServicesConfiguration.vue";
import Reports from "@/views/Reports.vue";

import AITools from '../views/AITools.vue';
import Workflows from '../views/Workflows.vue';
import WorkflowEditor from '@/components/WorkflowEditor.vue';
import Unauthorized from "../views/Unauthorized.vue";
import AgentStyles from '../views/AgentStyles.vue';
import CommunicationSources from '../views/CommunicationSources.vue';
import WhatsAppTemplates from '../views/WhatsAppTemplates.vue';
import MCPConnections from '../views/MCPConnections.vue';
import WebsiteAiView from '../views/WebsiteAiView.vue';
import WebVoiceAgent from '../views/WebVoiceAgent.vue';

import Roles from '../views/Roles.vue';
import Divisions from '../views/Divisions.vue';
import HelpAgent from '../views/HelpAgent.vue'; 
import LiveSessions from '../views/LiveSessions.vue'; 
import APIDocs from '../views/APIDocs.vue';
import TermsAndPolicies from '../views/TermsAndPolicies.vue';
import DpaPreview from '../views/DpaPreview.vue';
import Security from '../views/Security.vue';
import HealthCheckView from '../views/HealthCheckView.vue';
import DeploymentHealthView from '../views/DeploymentHealthView.vue';
import FileProcessingQa from '../views/qa/FileProcessingQa.vue';
import ReportDashboards from '../views/ReportDashboards.vue';
import ApplicationsView from '../views/ApplicationsView.vue';
import ApplicationAgentView from '../views/ApplicationAgentView.vue';
import TagsManager from '../views/TagsManager.vue';
import UnansweredQuestions from '../views/UnansweredQuestions.vue';
import AuditLogs from '../views/AuditLogs.vue';
import ApplicationFullscreenView from '../views/ApplicationFullscreenView.vue';
import GeniAgentCreator from '../views/GeniAgentCreator.vue';
import OrganizationUsage from '../views/OrganizationUsage.vue';
import AgentEvals from '../views/AgentEvals.vue';
import AutoAgent from '../views/AutoAgent.vue';
const AutomaticAgentCreator = () => import('../views/AutomaticAgentCreator.vue');
const MarketplaceHome = () => import('../views/MarketplaceHome.vue'); 
const MarketplaceCategoryView = () => import('../views/MarketplaceCategoryView.vue');
const MarketplaceItemDetail = () => import('../views/MarketplaceItemDetail.vue');
const CustomDesign = () => import('../views/CustomDesign.vue');
const PlatSet = () => import('../views/platSet.vue');
const Diagnosis = () => import('../views/Diagnosis.vue');
const ScrapeWebsiteTest = () => import('../views/ScrapeWebsiteTest.vue');
const CustomSession = () => import('../views/CustomSession.vue');
var appname = " - Enterprise Agentic System";
const activeThemeForRoutes = getActiveThemeKey();
let aiChatsRouteComponent = AIChats;
if (activeThemeForRoutes === 'modern') {
  aiChatsRouteComponent = ModernAIChats;
} else if (activeThemeForRoutes === 'light') {
  aiChatsRouteComponent = LightAIChats;
}

const routes = [

  {
    path: '/termsAndConditions',
    name: 'TermsAndPolicies',
    component: TermsAndPolicies,
    meta: { title: 'Terms and Policies', requiresAuth: false }
  },
  {
    path: '/legal/dpa',
    name: 'DpaPreview',
    component: DpaPreview,
    meta: { title: 'Data Processing Addendum (DPA)', requiresAuth: false, noLayout: true, hideNav: true, hideFooter: true }
  },
  {
    path: "/",
    name: "Dashboard",
    component: DashboardV3,
    meta: { title: "Dashboard " + appname, fillViewport: true },
  },

  {
    path: "/geni",
    name: "GeniAgentCreator",
    component: GeniAgentCreator,
    meta: { title: "Geni – Agent Creator" + appname, requiresAuth: true },
  },
  {
    path: "/AutomaticAgentCreator",
    name: "AutomaticAgentCreator",
    component: AutomaticAgentCreator,
    meta: { title: "Automatic Agent Creator" + appname, requiresPermission: 'createAiAgent' },
  },
  {
    path: "/autoAgent",
    name: "AutoAgent",
    component: AutoAgent,
    meta: { title: "Auto Agent" + appname, requiredAnyPermissions: ['createAiAgent','editAgents','modifyAiAgent'] },
  },

  {
    path: "/organizationSettings",
    name: "Organization Settings",
    component: OrganizationSettings,
    meta: { title: "Organization Settings" + appname, requiresPermission: 'fullAccessToOrganization' }, 
  },
  {
    path: "/security",
    name: "Security",
    component: Security,
    meta: { title: "Security" + appname, requiresPermission: 'fullAccessToOrganization' },
  },
  {
    path: "/platSet",
    name: "PlatformSettings",
    component: PlatSet,
    meta: { title: "Platform Settings" + appname, requiresAuth: true, requiresPermission: 'managePlatformSettings' },
  },
  {
    path: "/healthCheck", 
    name: "HealthCheck",
    component: HealthCheckView,
    meta: { title: "Health Check" + appname, requiresAuth: true },
  },
  {
    path: "/health/deployment",
    name: "DeploymentHealth",
    component: DeploymentHealthView,
    meta: { title: "Deployment Health" + appname, requiresAuth: true, requiresPermission: 'fullAccessToOrganization' },
  },
  {
    path: "/diagnosis",
    name: "Diagnosis",
    component: Diagnosis,
    meta: { title: "Diagnosis" + appname, requiresAuth: true, requiresPermission: 'fullAccessToOrganization' },
  },
  {
    path: "/qa/file-processing",
    name: "QaFileProcessing",
    component: FileProcessingQa,
    meta: { title: "QA File Processing" + appname, requiresAuth: true },
  },
  {
    path: "/qa/fileprocessing",
    redirect: "/qa/file-processing",
  },
  {
    path: "/scarpe/website/test",
    name: "ScrapeWebsiteTest",
    component: ScrapeWebsiteTest,
    meta: { title: "Website Markdown Preview" + appname, requiredAnyPermissions: ['viewAgents','viewAiAgents','modifyAiAgent','editAgents'] },
  },
  {
    path: "/customSession",
    name: "CustomSession",
    component: CustomSession,
    meta: { title: "Custom Session" + appname, requiresAuth: true, requiredAnyPermissions: ['viewAiAgents','modifyAiAgent','editAgents'] },
  },
  {
    path: "/aiChatAgents",
    name: "AI Chat Agents",
    component: aiChatsRouteComponent,
    meta: { title: "AI Chats " + appname, requiredAnyPermissions: ['viewAiAgents','modifyAiAgent', 'editAgents'], fillViewport: true },
  },
  {
    path: "/aiChatAgentSetup",
    name: "AI Chat Agents Setup",
    component: AIChatAgentSetup,
    meta: {  title: "AI Chat Agent Setup" + appname, requiredAnyPermissions: ['createAiAgent','editAgents','modifyAiAgent'] },
  },
  {
    path: "/aiChatAgentSetupLight",
    name: "AI Chat Agents Setup Light",
    component: AIChatAgentSetupLight,
    meta: { title: "AI Chat Agent Setup Light" + appname, requiredAnyPermissions: ['createAiAgent','editAgents','modifyAiAgent'] },
  },
  {
    path: "/aiPhoneIvrSetup",
    name: "AI Phone IVR Setup",
    component: AIPhoneIVRSetup,
    meta: { title: "AI Phone IVR Setup" + appname, requiredAnyPermissions: ['createAiAgent','editAgents','modifyAiAgent'] },
  },
  {
    path: "/voiceAgentSetup",
    name: "Voice Agent Setup",
    component: VoiceAgentSetup,
    meta: { title: "Voice Agent Setup" + appname, requiredAnyPermissions: ['createAiAgent','editAgents','modifyAiAgent'] },
  },
  {
    path: "/voicePlayground",
    name: "VoicePlayground",
    component: VoicePlayground,
    meta: { title: "Voice Playground" + appname, requiredAnyPermissions: ['createAiAgent','editAgents','modifyAiAgent'] },
  },
  
  
   


  
  {
    path: "/organizationDiagram",
    name: "Organization Diagram",
    component: OrganizationDiagram,
    meta: { title: "Organization Diagram" + appname },
  },
 




  
  {
    path: "/ROIInsights",
    name: "ROIInsights",
    component: ROIInsights,
    meta: { title: "ROI Insights " + appname },
  },

   
  
   
  
  
  
  {
    path: "/customActions",
    name: "custom Actions",
    component: CustomActions,
    meta: { title: "Custom Actions " + appname },
  },
  {
    path: "/compliances",
    name: "compliances",
    component: Complainces,
    meta: { title: "Compliances " + appname },
  },
  {
    path: "/analysisEngine",
    name: "Analysis Engine",
    component: AnalysisEngine,
    meta: { title: "Analysis Engine " + appname, requiresAuth: true, requiredAnyPermissions: ['viewAiAgents','modifyAiAgent','editAgents'] },
  },
  {
    path: "/entities",
    name: "Entities",
    component: Entities,
    meta: { title: "Entities " + appname, requiresAuth: true, requiredAnyPermissions: ['viewAiAgents','modifyAiAgent','editAgents'] },
  },
  {
    path: "/ServicesSettings",
    name: "Services Settings",
    component: ServicesSettings,
    meta: { title: "Services Settings " + appname },
  },
  

  

 
  
  


   

  
  



   
  
  

   
    
 
  
  {
    path: "/teams",
    name: "teams",
    component: Teams,
    meta: { title: "Teams" + appname },
  },
  {
    path: "/thirdPartyIntegrations",
    name: "thirdPartyIntegrations",
    component: ThirdPartyIntegrations,
    meta: { title: "Third Party Integrations " + appname, requiresPermission: 'manageIntegrations' },
  },
  {
    path: "/integrations",
    name: "integrationsHome",
    component: () => import("@/views/IntegrationsHome.vue"),
    meta: { title: "Integrations " + appname, requiresAuth: true, requiredPermissions: ['accessSidebar'] },
  },
  {
    path: "/integrations/:itemId",
    name: "integrationDetail",
    component: () => import("@/views/Integration.vue"),
    props: true,
    meta: { title: "Integration " + appname, requiresAuth: true, requiredPermissions: ['accessSidebar'] },
  },
  {
    path: "/agents",
    name: "Agents",
    component: Agents,
    meta: { title: "Agents" + appname, requiresAuth: false },
  },
  {
    path: "/users",
    name: "Users",
    component: Users,
    meta: { title: "Users" + appname, requiresPermission: 'manageUsers' },
  },
  {
    path: "/organizationApiKeys",
    name: "ApiKeys",
    component: APIKeys,
    meta: { title: "API Keys" + appname, requiresPermission: 'manageApiKeys' },
  },
  {
    path: "/chat",
    name: "Chat",
    component: Chat,
    meta: { title: "Chat" + appname, hideFooter: true, fillViewport: true },
  },
  {
    path: "/agent/create",
    name: "AgentCreate",
    component: AgentCreate,
    meta: { title: "Create Agent" + appname, requiredAnyPermissions: ['createAiAgent', 'editAgents', 'modifyAiAgent'], hideFooter: true },
  },

  {
    path: "/component/alert",
    name: "Valert",
    component: Valert,
    meta: { title: "Alert" + appname },
  },
  {
    path: "/component/accordion",
    name: "Vaccordion",
    component: Vaccrodion,
    meta: { title: "Accordion" + appname },
  },
  {
    path: "/component/badge",
    name: "Vbadge",
    component: Vbadges,
    meta: { title: "Badge" + appname },
  },
  {
    path: "/component/breadcumb",
    name: "Vbreadcumb",
    component: Vbreadcumb,
    meta: { title: "Breadcumb" + appname },
  },
  {
    path: "/component/button",
    component: Vbutton,
    meta: { title: "Button" + appname },
  },
  {
    path: "/component/card",
    component: Vcard,
    meta: { title: "Card" + appname },
  },
  {
    path: "/component/dropdown",
    component: Vdropdown,
    meta: { title: "Dropdown" + appname },
  },
  {
    path: "/component/modal",
    component: Vmodal,
    meta: { title: "Modal" + appname },
  },


  {
    path: "/Blank",
    name: "Blank Page",
    component: Blank,
    meta: { title: "Blank Page" + appname },
  },

  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { title: "Login" + appname, hideNav: true, noLayout: true, requiresAuth: false },
  },
  
   

  
   
 
  
  
 
    
   
  
  
  {
    path: "/:pathMatch(.*)*",
    name: "Page404",
    component: Page404,
    meta: { title: "Upps! 404" + appname, hideNav: true ,hideFooter: true, requiresAuth: false },
  },
  {
    path: "/500",
    name: "Page500",
    component: Page500,
    meta: { title: "Server internal Error" + appname, hideNav: true ,hideFooter: true, requiresAuth: false },
  },
  {
    path: "/maintenance",
    name: "maintenance",
    component: PageMaintenance,
    meta: {
      title: "Sorry the app has been Maintenance" + appname,
      hideNav: true,
      requiresAuth: false,
    },
  },
  
  


 
      

  
  {
    path: "/aiChatAgent/:agentid",
    name: "ChatAgent",
    component: PublicChatWidgetLoader,
    meta: { title: "Chat Agent" + appname, noLayout: true, requiresAuth: false },
  },
  {
    path: "/agent/:agentid",
    name: "Agent",
    component: PublicChatWidgetLoader,
    meta: { title: "Chat Agent" + appname, noLayout: true, requiresAuth: false },
  },
  {
    path: "/aiChatAgentAssistance/:agentid",
    name: "ChatAgentAssistance",
    component: ChatAgentAssistance,
    meta: { title: "AI Agent Assistance" + appname, hideFooter: true, requiresAuth: true, requiredAnyPermissions: ['viewAiAgents','modifyAiAgent', 'editAgents'] },
  },
  {
    path: "/websiteAi/:agentid",
    name: "WebsiteAiView",
    component: WebsiteAiView,
    meta: { title: "Website + AI" + appname, requiresAuth: false, noLayout: true }
  },
  {
    path: "/webVoiceAgent/:agentid",
    name: "WebVoiceAgent",
    component: WebVoiceAgent,
    meta: { title: "Web Voice Agent" + appname, requiresAuth: true, noLayout: true }
  },
  {
    path: "/aiServicesConfig",
    name: "AIServicesConfiguration",
    component: AIServicesConfiguration,
    meta: {  title: "AI Services Configuration" + appname },
  },
  {
    path: "/aiChat",
    name: "AIChat",
    component: Chat,
    meta: { title: "AI Chat" + appname, requiresAuth: true, hideFooter: true },
  },
  

    
 


      {
        path: '/reports',
        name: 'Reports',
        component: Reports,
        meta: { title: 'Reports', requiresAuth: true, requiresPermission: 'viewReports' }
      },
  {
    path: '/customReports',
    name: 'CustomReports',
    component: () => import('../views/CustomReports.vue'),
    meta: { title: 'Custom Reports' + appname, requiresAuth: true, requiresPermission: 'viewReports' }
  },
  {
    path: '/customReportButtons',
    name: 'CustomReportButtons',
    component: () => import('../views/CustomReportButtons.vue'),
    meta: { title: 'Custom Report Buttons' + appname, requiresAuth: true, requiresPermission: 'viewReports' }
  },
  {
    path: '/campaigns',
    name: 'Campaigns',
    component: () => import('../views/Campaigns.vue'),
    meta: { title: 'Campaigns' + appname, requiresAuth: true, requiresPermission: 'viewReports' }
  },
  {
    path: '/reportDashboards',
    name: 'ReportDashboards',
    component: ReportDashboards,
    meta: { title: 'Report Dashboards' + appname, requiresAuth: true, requiresPermission: 'viewReports' }
  },
  {
    path: '/organizationUsage',
    name: 'OrganizationUsage',
    component: OrganizationUsage,
    meta: { title: 'Organization Usage Dashboard' + appname, requiresAuth: true, requiredAnyPermissions: ['viewReports','viewAiAgents','modifyAiAgent'] }
  },
  {
    path: '/auditLogs',
    name: 'AuditLogs',
    component: AuditLogs,
    meta: { title: 'Audit Logs' + appname, requiresAuth: true, requiredAnyPermissions: ['viewAuditReports','fullAccessToOrganization'] }
  },
  {
    path: '/aiTools',
    name: 'AITools',
    component: AITools,
    meta: { requiresAuth: true, requiredAnyPermissions: ['modifyAiAgent','viewTools'] }
  },
  {
    path: '/aiAgentsTools',
    name: 'AITools',
    component: AITools,
    meta: { requiredAnyPermissions: ['modifyAiAgent','viewTools'] }
  },
  {
    path: '/workflows',
    name: 'Workflows',
    component: Workflows,
    meta: { requiresAuth: true, requiredAnyPermissions: ['modifyAiAgent','viewTools','editAgents'] }
  },
  {
    path: '/workflowEditor',
    name: 'WorkflowEditor',
    component: WorkflowEditor,
    alias: ['/workfloweditor', '/workflowsEditor', '/workflowseditor'],
    meta: { requiresAuth: true, requiredAnyPermissions: ['modifyAiAgent','viewTools','editAgents'] }
  },
  {
    path: "/unauthorized",
    name: "Unauthorized",
    component: Unauthorized,
    meta: { title: "Unauthorized Access" + appname, hideNav: true,hideFooter: true  },
  },
  {
    path: '/aiAgentsStyling',
    name: 'AgentStyles',
    component: AgentStyles,
    meta: { title: 'AI Agents Styling' + appname, requiredAnyPermissions: ['manageAiStyles','modifyAiAgent'] },
  },

  {
    path: '/communicationSources',
    name: 'CommunicationSources',
    component: CommunicationSources,
    meta: { title: 'Communication Sources' + appname, requiresPermission: 'fullAccessToOrganization' },
  },
  {
    path: '/whatsappTemplates',
    name: 'WhatsAppTemplates',
    component: WhatsAppTemplates,
    meta: { title: 'WhatsApp Templates' + appname, requiresPermission: 'fullAccessToOrganization' },
  },
  {
    path: '/mcpConnections',
    name: 'MCPConnections',
    component: MCPConnections,
    meta: { title: 'MCP Connections' + appname, requiresPermission: 'fullAccessToOrganization' },
  },

  {
    path: "/roles",
    name: "Roles",
    component: Roles,
    meta: { title: "Roles " + appname, hideFooter: true, requiresPermission: 'manageRoles' },
  },
  {
    path: "/divisions",
    name: "Divisions",
    component: Divisions,
    meta: { title: "Divisions " + appname, requiresPermission: 'manageDivisions' },
  },
  
   
  
  
     
  
  {
    path: '/liveSessions',
    name: 'LiveSessions',
    component: LiveSessions,
    meta: { requiresAuth: true, title: 'Live Sessions', requiresPermission: 'viewReports' } 
  },
  {
    path: '/tags',
    name: 'Tags',
    component: TagsManager,
    meta: { requiresAuth: true, title: 'Tags', requiresPermission: 'viewTags' } 
  },
  {
    path: '/unansweredQuestions',
    name: 'UnansweredQuestions',
    component: UnansweredQuestions,
    meta: { requiresAuth: true, title: 'Unanswered Questions' + appname, requiresPermission: 'viewReports' } 
  },
  {
    path: '/documentation',
    name: 'APIDocs',
    component: APIDocs,
    meta: { title: 'API Documentation' + appname, noLayout: true, requiresAuth: true, requiresPermission: 'viewApiDocs' }
  },
  {
    path: "/applications",
    name: "Applications",
    component: ApplicationsView,
    meta: { title: "Applications" + appname, requiresAuth: true },
  },
  {
    path: "/applicationAgent/:appId",
    name: "ApplicationAgent",
    component: ApplicationAgentView,
    meta: { title: "Application Agent" + appname, requiresAuth: true },
  },
  {
    path: '/marketplace',
    name: 'MarketplaceHome',
    component: MarketplaceHome,
    meta: { requiresAuth: true, requiredPermissions: ['accessSidebar'] }
  },
  {
    path: '/marketplace/:category',
    name: 'MarketplaceCategoryView',
    component: MarketplaceCategoryView,
    props: true,
    meta: { requiresAuth: true, requiredPermissions: ['accessSidebar'] } 
  },
  {
    path: '/marketplace/:category/:itemId',
    name: 'MarketplaceItemDetail',
    component: MarketplaceItemDetail,
    props: true,
    meta: { requiresAuth: true, requiredPermissions: ['accessSidebar'] } 
  },
  {
    path: '/app/:appId/fullscreen',
    name: 'ApplicationFullscreen',
    component: ApplicationFullscreenView,
    props: true,
    meta: { hideSidebar: true, hideHeader: false }
  },
  {
    path: '/customDesign',
    name: 'CustomDesign',
    component: CustomDesign,
    meta: { title: 'Custom Design' + appname, requiresAuth: true, requiresPermission: 'manageOrganizationSettings' }
  },
  {
    path: '/tokenUsage',
    name: 'TokenUsage',
    component: () => import('../views/TokenUsage.vue')
  }
  ,
  {
    path: '/agentEvals',
    name: 'AgentEvals',
    component: AgentEvals,
    meta: { title: 'Agent Evals' + appname, requiredAnyPermissions: ['viewAiAgents','modifyAiAgent','editAgents'] }
  }
  ,
  {
    path: '/sharedKnowledgeBases',
    name: 'SharedKnowledgeBases',
    component: () => import('../views/SharedKnowledgeBases.vue'),
    meta: { title: 'Shared Knowledge Bases' }
  },
  {
    path: '/termsPackages',
    name: 'TermsPackages',
    component: () => import('../views/TermsPackages.vue'),
    meta: { title: 'Terms Packages' + appname, requiredAnyPermissions: ['viewAiAgents','modifyAiAgent','editAgents'] }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,

  scrollBehavior(to, from, savedPosition) {
    if (to.hash !== undefined && to.hash !== null && to.hash !== '') {
      return { el: to.hash, behavior: 'smooth' };
    }
    return { top: 0 };
  },

  linkExactActiveClass: "exact-active",
});


async function ensureUserInfoLoaded() {
  if (globalState.userInfoValidatedAt !== null && globalState.userInfoValidatedAt !== undefined) {
    return true;
  }
  try {
    const userData = await fetchUserData();
    if (userData !== null && userData !== undefined) {
      globalState.userInfo = userData;
      globalState.userInfoValidatedAt = Date.now();
      return true;
    }
  } catch (e) {}
  globalState.userInfo = null;
  globalState.userInfoValidatedAt = null;
  return false;
}

function getUserPermissions() {
  const userInfo = globalState.userInfo;
  if (userInfo !== null && userInfo !== undefined && Array.isArray(userInfo.permissions) === true) {
    return userInfo.permissions;
  }
  return [];
}

function getUserRoles() {
  const userInfo = globalState.userInfo;
  if (userInfo !== null && userInfo !== undefined && Array.isArray(userInfo.roles) === true) {
    return userInfo.roles;
  }
  return [];
}


router.beforeEach(async (to, from, next) => {
  const isPublic = to.matched.some(record => record.meta.requiresAuth === false);
  const requiresAuth = isPublic === false;
  const requiresPermission = to.meta.requiresPermission !== undefined && to.meta.requiresPermission !== null ? to.meta.requiresPermission : undefined;
  const requiredPermissions = Array.isArray(to.meta.requiredPermissions) === true ? to.meta.requiredPermissions : undefined;
  const requiredAnyPermissions = Array.isArray(to.meta.requiredAnyPermissions) === true ? to.meta.requiredAnyPermissions : undefined;
  const needsUserInfo = requiresAuth === true || requiresPermission !== undefined || requiredPermissions !== undefined || requiredAnyPermissions !== undefined;
  let loggedIn = true;
  if (needsUserInfo === true) {
    loggedIn = await ensureUserInfoLoaded();
  }

  document.title = to.meta.title !== undefined && to.meta.title !== null ? to.meta.title : 'Enterprise Agent Platform'; 

  function checkAccess() {
    const userPermissions = getUserPermissions();
    const hasOrgFull = userPermissions.includes('fullAccessToOrganization') === true;
    if (hasOrgFull === true) return true;
    if (requiresPermission !== undefined) {
      return userPermissions.includes(requiresPermission) === true;
    }
    if (requiredPermissions !== undefined) {
      return requiredPermissions.every(p => userPermissions.includes(p) === true) === true;
    }
    if (requiredAnyPermissions !== undefined) {
      return requiredAnyPermissions.some(p => userPermissions.includes(p) === true) === true;
    }
    return true;
  }

  if (requiresAuth === true && loggedIn === false) {
    console.log(`Router Guard: Auth required for ${to.fullPath}, user not logged in. Redirecting to login.`);
    next({ name: 'Login', query: { redirect: to.fullPath } });
  } else if (requiresAuth === true && loggedIn === true) {
    if (requiresPermission !== undefined || requiredPermissions !== undefined || requiredAnyPermissions !== undefined) {
      if (checkAccess() === true) {
        next();
      } else {
        console.log(`Router Guard: Permission denied for ${to.fullPath}. Redirecting to Unauthorized.`);
        next({ name: 'Unauthorized' });
      }
    } else {
      next();
    }
  } else if (requiresAuth === false && (requiresPermission !== undefined || requiredPermissions !== undefined || requiredAnyPermissions !== undefined)) {
    if (loggedIn === true) {
      if (checkAccess() === true) {
        next();
      } else {
        console.log(`Router Guard: Permission denied for ${to.fullPath} (auth not explicitly required). Redirecting to Unauthorized.`);
        next({ name: 'Unauthorized' });
      }
    } else {
      console.log(`Router Guard: Permission required for ${to.fullPath}, user not logged in. Redirecting to login.`);
      next({ name: 'Login', query: { redirect: to.fullPath } });
    }
  } else {
    next();
  }
});

export default router;


